import axios from 'axios'

axios.defaults.headers.common['X-Format-Date'] = 'ISO8601' // for bubble theme



// WEBPACK FOOTER //
// ./src/plugins/utilities/axios.js